module.exports = __webpack_public_path__ + "static/media/SellerboxMain03.fdbd96e8.png";